import React, { useEffect } from "react";
import { useWizard } from "react-use-wizard";
import SingleChoiceV2WithoutSubmit from "../../components/singleChoiceV2WithoutSubmit";
import { useTranslation } from "react-i18next";
import NavigateBackWizardStep from "../../components/navigateBackWizardStep";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const SingleChoiceStep = ({
  question,
  choices,
  initState,
  onSubmitHandler,
  qKey,
  isFirstWizardStep,
}) => {
  const [selectedChoice, setSelectedChoice] = React.useState(() => {
    if (initState && typeof initState === "object") {
      return initState;
    }
    return { value: null, text: null, id: null };
  });

  const history = useHistory();

  const { previousStep, nextStep, goToStep } = useWizard();

  const { t } = useTranslation();

  const handleSubmit = () => {
    onSubmitHandler({
      [qKey]: {
        _state: selectedChoice,
      },
    });
    nextStep();
  };

  const onOptionChange = (choiceInfo) => {
    setSelectedChoice(choiceInfo);
  };

  const handleBack = () => {
    if (isFirstWizardStep) {
      history.goBack(); // or history.push('/your-route') to go to a specific path
    } else {
      previousStep();
    }
  };

  return (
    <>
      <NavigateBackWizardStep
        clickHandler={handleBack}
        title={t("title")}
        hideLibrary={true}
      />
      <div className="body_content">
        <div className="inner_body">
          <SingleChoiceV2WithoutSubmit
            question={question}
            choices={choices}
            qKey={qKey}
            selectedChoice={selectedChoice}
            onChange={onOptionChange}
          />
        </div>
        <div className="btn_block bottom_button d-flex justify-content-center">
          <button
            className="btn btn_primary nextstep_cta"
            disabled={selectedChoice?.value == null}
            onClick={() => handleSubmit()}
          >
            {t("login.DOBSTEP.button")}
          </button>
        </div>
      </div>
    </>
  );
};

export default SingleChoiceStep;
